<template>
  <div v-if="delegation" class="deleg-banner">
    <div class="deleg-inner">
      <svg viewBox="0 0 24 24" width="16" height="16" fill="none" stroke="currentColor" stroke-width="2">
        <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"/><circle cx="9" cy="7" r="4"/>
        <path d="M23 21v-2a4 4 0 0 0-3-3.87M16 3.13a4 4 0 0 1 0 7.75"/>
      </svg>
      <span class="deleg-text">
        <template v-if="scopeLabel">
          Vous collaborez sur {{ scopeLabel }} du compte <strong>{{ activeLabel.name }}</strong>
          (rôle {{ roleLabel(delegation.role) }}).
        </template>
        <template v-else>
          Vous travaillez dans le compte <strong>{{ activeLabel.name }}</strong>
          (partagé, rôle {{ roleLabel(delegation.role) }}).
        </template>
      </span>
      <button class="deleg-back" @click="back">Revenir à mon compte</button>
    </div>
  </div>
</template>

<script>
import { getDelegation, getActiveAccountLabel, getScopeLabel, switchBack } from '@/utils/accountSwitch';

export default {
  name: 'DelegationBanner',
  data() {
    return { delegation: getDelegation(), activeLabel: getActiveAccountLabel(), scopeLabel: getScopeLabel() };
  },
  methods: {
    roleLabel(r) { return { admin: 'Administrateur', editor: 'Éditeur', viewer: 'Lecteur' }[r] || r; },
    back() { switchBack(); }
  }
};
</script>

<style scoped>
.deleg-banner { background: #143028; color: #DAFFD1; width: 100%; }
.deleg-inner {
  display: flex; align-items: center; gap: 12px; max-width: 1200px; margin: 0 auto;
  padding: 10px 18px; font-size: 13.5px;
}
.deleg-text { flex: 1; }
.deleg-back {
  background: #DAFFD1; color: #143028; border: none; padding: 7px 14px; border-radius: 8px;
  font-weight: 600; font-size: 13px; cursor: pointer; white-space: nowrap;
}
.deleg-back:hover { background: #c6f0b8; }
</style>
